import { useEffect, useState } from 'react';
import { Footer } from '../../../components/footer';
import { Link, useNavigate } from 'react-router-dom';
import { InputGroup, Input, InputGroupAddon, InputGroupText, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { useDebounce } from '../../../hook/debounce';
import { useGetTicketHistory } from './api/api';
import { Check, Eye } from 'lucide-react';
import Loader from '../../Loader/buttonLoad';
import moment from 'moment';
import { copyToClipboard } from '../../../lib/copytoClipboard';
import { useToast } from '../../../hook/usetoast';
import Aos from 'aos';

const SupportTicket = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
      Aos.init({ once: true });
   }, []);

 
   const toast = useToast()
   const navigate = useNavigate()
   const [type, setType] = useState("all");
   const [search, setSearch] = useState("");
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const searchtrans = useDebounce(search);
   const { data: getTicketHistory, isLoading } = useGetTicketHistory({
      page: page,
      size: rowsPerPage,
      search: searchtrans,
      type: type
   });
   const totalPages = Math.ceil(getTicketHistory?.count / rowsPerPage);

   const handlePageChange = (newPage) => {

      const currentScrollY = window.scrollY;
      if (newPage >= 0 && newPage < totalPages) {
         setPage(newPage);


         window.requestAnimationFrame(() => {
            window.scrollTo(0, currentScrollY);
         });
      }
   };
   const [uniqueId, setUniqueId] = useState(false)

   const copyUserId = async data => {
      setUniqueId(data)
      await copyToClipboard(data)
      toast.success("Ticket Id is copied")
      setTimeout(() => {
         setUniqueId(false)
      }, 300);
   }
   return (


      <>
         {isLoading && <Loader />}
         <div className="mainContent">
            <div className="pageContent def-py-30">
               <div className='container'>
                  <div className="d-flex g-10 flex-wrap justify-content-between mb-3 mb-md-0">
                     <div className="appPagetitle">Support Ticket</div>
                     <Link to="/create-ticket" className='btn btn-primary d-inline-flex align-items-center g-10 ml-auto'>
                        <span>Create Ticket</span>
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <circle cx="15" cy="15" r="15" fill="currentColor" />
                           <path d="M20.436 14.8081V16.5721H15.732V20.8841H13.94V16.5721H9.208V14.8081H13.94V10.4961H15.732V14.8081H20.436Z" fill="currentColor" style={{ filter: 'invert(1)' }} />
                        </svg>
                     </Link>
                  </div>
                  <div className='row'>
                     <div className="col-lg-12">


                        <div className="appcard px-0 pb-2 cardbg">

                           <div className="px-4 mb-4">
                              <div className='row justify-content-between'>
                                 <div className="col-md mb-2 mb-md-0 text-center text-md-left">
                                    <div className='d-inline-flex g-8 align-items-center'>
                                       <span className='fs-18 fw-400 text-white-60'>Show</span>
                                       <div className='form-group mb-0 formInputs gradientBg'>
                                          <select className='form-control' onChange={(e) => {
                                             setRowsPerPage(Number(e.target.value));
                                             setPage(0);
                                          }}>
                                             <option value="10">10</option>
                                             <option value="30">30</option>
                                             <option value="50">50</option>
                                          </select>
                                       </div>
                                       <span className='fs-18 fw-400 text-white-60'>entries</span>
                                    </div>
                                 </div>
                                 <div className='col-md-auto'>
                                    <div className='form-inline justify-content-md-end justify-content-center'>
                                       <div className="formInputs form-group gradientBg px-2">
                                          <select name="" id="" value={type} onChange={(e) => setType(e.target.value)} className="form-control mx-1">
                                             <option value="all">All</option>
                                             <option value="new">New</option>
                                             <option value="pending">In Progress</option>
                                             <option value="closed">Solved</option>
                                          </select>
                                       </div>
                                       <div className="formInputs form-group gradientBg">
                                          <InputGroup>
                                             <InputGroupAddon addonType="prepend" tag='div'>
                                                <InputGroupText className='pl-0'>
                                                   <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <path d="M2.25 7.5C2.25 8.18944 2.3858 8.87213 2.64963 9.50909C2.91347 10.146 3.30018 10.7248 3.78769 11.2123C4.2752 11.6998 4.85395 12.0865 5.49091 12.3504C6.12787 12.6142 6.81056 12.75 7.5 12.75C8.18944 12.75 8.87213 12.6142 9.50909 12.3504C10.146 12.0865 10.7248 11.6998 11.2123 11.2123C11.6998 10.7248 12.0865 10.146 12.3504 9.50909C12.6142 8.87213 12.75 8.18944 12.75 7.5C12.75 6.81056 12.6142 6.12787 12.3504 5.49091C12.0865 4.85395 11.6998 4.2752 11.2123 3.78769C10.7248 3.30018 10.146 2.91347 9.50909 2.64963C8.87213 2.3858 8.18944 2.25 7.5 2.25C6.81056 2.25 6.12787 2.3858 5.49091 2.64963C4.85395 2.91347 4.2752 3.30018 3.78769 3.78769C3.30018 4.2752 2.91347 4.85395 2.64963 5.49091C2.3858 6.12787 2.25 6.81056 2.25 7.5Z" stroke="white" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round" />
                                                      <path d="M15.75 15.75L11.25 11.25" stroke="white" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round" />
                                                   </svg>
                                                </InputGroupText>
                                             </InputGroupAddon>
                                             <Input type='text' placeholder='Search' value={search} onChange={(e) => setSearch(e.target.value)} />
                                          </InputGroup>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div className='table-responsive mb-3 text-nowrap'>
                              <table className='table myapptable table-hover table-borderless mb-0'>
                                 <thead>
                                    <tr>
                                       <th>S.No</th>

                                       <th className='pl-4'>Ticket ID</th>
                                       <th>Subject</th>
                                       <th>Created On</th>
                                       <th >Status</th>
                                       <th className='text-right pr-4'>Action</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                   
                                    {
                                       getTicketHistory?.data?.length > 0 ? (
                                          getTicketHistory?.data.map((v, i) => {
                                             // Status display logic
                                             const status = v?.status?.toLowerCase();
                                             const getStatusDisplay = () => {
                                                if (status === 'pending') {
                                                   return <span className="text-lightyellow">pending</span>;
                                                } else if (status === 'new') {
                                                   return <span className="text-lightyellow">new</span>;
                                                } else if (status === 'closed') {
                                                   return <span className="text-lightgreen">solved</span>;
                                                }
                                                return <span>-</span>;
                                             };

                                             return (
                                                <tr key={v?.ticketId || i}> {/* Better key: use ticketId */}
                                                   <td>{page * rowsPerPage + (i + 1)}</td>
                                                   <td className='pl-4'>
                                                      <div className="d-flex g-8">
                                                         <span>{v?.ticketId}</span>
                                                         {uniqueId === v?.ticketId ? (
                                                            <Check size={20} color={"#FCD535"} cursor={'not-allowed'} />
                                                         ) : (
                                                            <button className='btn btnEmpty' onClick={() => copyUserId(v?.ticketId)}>
                                                               <img src={require('../../../assets/images/master-wallet/copyIcon.svg').default} alt='copyIcon' />
                                                            </button>
                                                         )}
                                                      </div>
                                                   </td>
                                                   <td>{v?.subject}</td>
                                                   <td>{moment(v?.createdAt).format("DD/MM/YYYY | hh:mm A")}</td>
                                                   <td>{getStatusDisplay()}</td> {/* ✅ Dynamic based on v?.status */}
                                                   <td className='text-right pr-4'>
                                                      <button className="btn btn-secondary" onClick={() => navigate(`/view-ticket/${v.ticketId}`)}>
                                                         <Eye className='eye text-white' />
                                                      </button>
                                                   </td>
                                                </tr>
                                             );
                                          })
                                       ) : (
                                          <tr>
                                             <td colSpan="6" className="text-center">No data found</td> {/* ✅ Fixed: 6 columns */}
                                          </tr>
                                       )
                                    }
                                 </tbody>
                              </table>
                           </div>
                           <div className="px-4">
                              <div className='row'>
                                 <div className='col-lg-12'>
                                    <Pagination aria-label="Page navigation" className='customPagination'>

                                       <PaginationItem disabled={page === 0}>
                                          <PaginationLink previous href="#" onClick={() => handlePageChange(page - 1)} className='prevbtn'>
                                             <i className='bi bi-arrow-left align-bottom'></i> Previous
                                          </PaginationLink>
                                       </PaginationItem>
                                       <span className='number'>
                                          {totalPages > 6 && page > 3 && (
                                             <>
                                                <PaginationItem key={0} active={page === 0}>
                                                   <PaginationLink href="#" onClick={() => handlePageChange(0)}>
                                                      1
                                                   </PaginationLink>
                                                </PaginationItem>
                                                <PaginationItem disabled>
                                                   <PaginationLink href="#">
                                                      ...
                                                   </PaginationLink>
                                                </PaginationItem>
                                             </>
                                          )}

                                          {/* Show pages near the current page */}
                                          {Array.from({ length: totalPages }, (_, index) => {
                                             if (index === 1 || index === 2 || index === totalPages - 0 || (index >= page - 2 && index <= page + 2)) {
                                                return (
                                                   <PaginationItem key={index} active={index === page}>
                                                      <PaginationLink href="#" onClick={() => handlePageChange(index)}>
                                                         {index + 1}
                                                      </PaginationLink>
                                                   </PaginationItem>
                                                );
                                             }
                                             return null;
                                          })}

                                          {totalPages > 6 && page < totalPages - 4 && (
                                             <>
                                                <PaginationItem disabled>
                                                   <PaginationLink href="#">
                                                      ...
                                                   </PaginationLink>
                                                </PaginationItem>
                                                <PaginationItem key={totalPages - 1} active={page === totalPages - 1}>
                                                   <PaginationLink href="#" onClick={() => handlePageChange(totalPages - 1)}>
                                                      {totalPages}
                                                   </PaginationLink>
                                                </PaginationItem>
                                             </>
                                          )}
                                       </span>

                                       <PaginationItem disabled={page === totalPages - 1}>
                                          <PaginationLink next href="#" onClick={() => handlePageChange(page + 1)} className='nextbtn'>
                                             Next <i className='bi bi-arrow-right align-bottom'></i>
                                          </PaginationLink>
                                       </PaginationItem>
                                    </Pagination>
                                 </div>
                              </div>
                           </div>
                        </div>


                     </div>
                  </div>

               </div>
            </div>
         </div>
         <Footer />
      </>
   )
}

export default SupportTicket;